/**
 * Bootstrap spinner for Drive Preact side pages while .json loads.
 */

import { h } from 'preact'

export function SidePageLoader({ label }) {
  return (
    <div class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{label}</span>
      </div>
    </div>
  )
}
